import React from 'react';
import { useHistory, useParams } from "react-router-dom";
import useFetcher from '../hooks/useFetcher.js';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { Loading } from '../components/Loading';
import ErrorPage from './ErrorPage';

function Detail(){
    const history = useHistory()
    const { id } = useParams();
    const { data, loading, error } = useFetcher(`https://api.themoviedb.org/3/movie/${id}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`);

    if(loading) return <Loading/>
    if(error) return <ErrorPage/>

    function handleBackToHome(){
        history.push('/')
    }

    return (
        <>
            <Container className="mt-5">
                <Row>
                    <Col sm={8}>
                        <Card>
                            <Card.Img variant="top" src={`https://image.tmdb.org/t/p/w500${data.backdrop_path}`} />
                        </Card>
                    </Col>
                    <Col sm={4}>
                        <Card className="text-left">
                            <Card.Header>{ data.title }</Card.Header>
                            <small className="pl-3 pt-3">Release date: { data.release_date}</small>
                            <Row>
                                <Col><small className="pl-3 pt-3">Popularity: { data.popularity}</small></Col>
                                <Col><small className="pl-3 pt-3">Vote: { data.vote_count}</small></Col>
                            </Row>
                            <Card.Body>
                                <Card className="p-2"><small>Genres:</small>
                                    <Row>
                                    {
                                        data.genres.map(genre => (
                                            <Col key={genre.id}><Badge variant="warning">{ genre.name }</Badge></Col>
                                        ))
                                    }
                                    </Row>
                                </Card>
                                <Card.Text>
                                    <small>
                                        { data.overview }
                                    </small>
                                </Card.Text>
                                <Button variant="primary" onClick={ handleBackToHome }>Back to Home</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Detail